<app-header
  [showLanguageToggler]="showLanguageToggler"
  [currentLanguage]="preferredLanguage$ | async"
  (languageChange)="toggleLanguage($event)"
  [loginUrl]="env.redirectUrl"
  >
</app-header>

<ng-container *transloco="let t; read: 'congratulationsWaitlist'">
  <div class="congratulationsWaitlistContainer">
    <h1 class="waitlistHeader">{{ t('notInAreaTitle') }}</h1>
    <p class="waitlistInstruction">
      {{ t('joinWaitlistText') }}
    </p>
    @if (showWaitlistBtn) {
      <div class="button-wrapper">
        <page-button (clicked)="joinWaitlistClicked()">{{ t('joinWaitlistBtnText') }}</page-button>
      </div>
    }
    @if (!showWaitlistBtn) {
      <p>{{ t('joinWaitlistThanksMessage') }}</p>
    }
    <page-button
      [config]="{
        rank: 'secondary-grey'
      }"
      class="waitlistBtn"
      (clicked)="homeBtnClick()"
      >{{ t('homepageBtn') }}</page-button
      >
    </div>
  </ng-container>
